import { h, render } from 'preact';
import './main.css';
import 'utils/accordion';
import Layout from 'utils/layout';
import Video from 'utils/video';
import SidePanel from 'utils/side-panel';
// import Animation from './utils/animations';
import Swiper from 'swiper';
import QuickView from './product/product-quickview';


(() => {
  window.Swiper = Swiper; // this needs to be here for Nosto
  // Animation();
  if (!customElements.get('side-panel'))
    customElements.define('side-panel', SidePanel);
  const mountPoint = document.querySelector('#product-quick-view');
  if (mountPoint) {
    render(
      <QuickView />, mountPoint);
  }
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
          module(element, { ...data, layout, videos });
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });
})();
